import StickyPageHeader from '../components/common/StickyPageHeader';
import ShipTypeList from '../components/lists/ShipTypeList';
import { useShipTypes } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminShipTypesPage = ({ routes }) => {
  const { allShipTypes } = useShipTypes();

  return (
    <>
      <StickyPageHeader isAdmin title="Settings / Ship Types" />
      <Layout
        showCarriersNavigation
        disableLoading={false}
        menuIndex={0}
        routes={routes}
      >
        <ShipTypeList id="shipTypes" shipTypes={allShipTypes} />
      </Layout>
    </>
  );
};

export default AdminShipTypesPage;
